// A campanha de matrículas pode começar antes da virada do ano letivo vigente.
export const ANO_MATRICULA = 2027;
export const TITULO_REQUERIMENTO = `REQUERIMENTO DE MATRÍCULA ${ANO_MATRICULA}`;
